import { GeoJSONGeometry } from '@atom/types/geojson';
import { FILES_ENDPOINT } from '@atom/utilities/endpoints';

import { getStaticImage } from '../../mapUtilities';

export const getSummaryImage = (
  mainPhotoFileId: string | undefined,
  location: GeoJSONGeometry | undefined,
  size: number,
): string =>
  mainPhotoFileId
    ? `${FILES_ENDPOINT}/${mainPhotoFileId}_${size}`
    : getStaticImage(location);
